import { render, staticRenderFns } from "./PaymentTariffForm.vue?vue&type=template&id=2d111edf&scoped=true&"
import script from "./PaymentTariffForm.vue?vue&type=script&lang=js&"
export * from "./PaymentTariffForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d111edf",
  null
  
)

export default component.exports